/**
 * External URLs used throughout the application
 */

export const EXTERNAL_URLS = {
  DOCUMENTATION: 'https://loada.io/docs',
} as const;
